<script setup lang="ts">
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Sliders/L Text R Slider3'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 px-xl xl:pl-2xl flex flex-col xl:grid grid-cols-12 gap-8 xl:gap-16 bg-background-2"
    >
      <div class="flex flex-col gap-10 col-span-5">
        <div class="px-3 py-5 border-b-5 border-Tertiary w-fit">
          <span class="text-H2 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
            />
          </span>
        </div>
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
        <CmsCustomComponentList
          v-slot="{ component_values: componentListValues }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1']"
          :open-options="true"
          component-name="elems_list"
          class="min-w-5 min-h-5 flex flex-col gap-10"
        >
          <div
            v-for="(item, index) in componentListValues"
            :key="JSON.stringify(item)"
            class="flex flex-row gap-5 items-start"
          >
            <CmsImage
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'image']"
              class="w-16 h-11"
            />
            <div class="flex flex-col gap-3">
              <span class="text-H4 text-Tekst font-semibold">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text_1']"
                />
              </span>
              <span class="text-Tekst text-Paragraph">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text_2']"
                />
              </span>
            </div>
          </div>
        </CmsCustomComponentList>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 xl:pt-24 xl:col-span-7"
      >
        <RSliderComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
